import React from 'react';
import PropTypes from 'prop-types';
import Phone from 'react-phone-number-input';
import { isNil } from 'ramda';

import CategoryPresenter from '../../../../presenters/CategoryPresenter';
import Label from '../../../../components/Label';
import Group from '../../../../components/Group';
import Column from '../../../../components/Column';
import Input from '../../../../components/Input';
import CategoryCheckbox from '../../../../components/CategoryCheckbox';

import CashbackRatesForm from './components/CashbackRatesForm';

const StoreInfoForm = (props) => {
  const {
    errors,
    values,
    categories,
    onChange,
    onCashbackRateChange,
    storeId,
  } = props;

  const handleFlagToggle = ({ target }) => {
    const { id, checked } = target;

    onChange(id, checked);
  };

  const handlePhoneNumberChange = (value) => {
    onChange('phoneNumber', value);
  };

  const handleChange = ({ target }) => {
    const { id, value } = target;

    onChange(id, value);
  };

  return (
    <Group>
      <h3>General</h3>
      <div className="form-group-fields">
        <Column>
          <div className="input">
            <Label name="name" title="Name" errors={errors} />
            <Input id="name" value={values.name} onChange={handleChange} />
          </div>

          <div className="input">
            <Label name="storeNumber" title="Store Number" errors={errors} />
            <Input
              id="storeNumber"
              value={values.storeNumber}
              onChange={handleChange}
            />
          </div>
          {isNil(storeId) && (
            <CashbackRatesForm
              values={values}
              onChange={onCashbackRateChange}
              errors={errors}
            />
          )}

          <div className="unique-in-state-field checkbox">
            <input
              type="checkbox"
              id="uniqueInState"
              checked={values.uniqueInState}
              onChange={handleFlagToggle}
            />
            <Label
              name="uniqueInState"
              title="Unique in State"
              errors={errors}
            />
          </div>

          <div className="fast-cash-enabled-field checkbox">
            <input
              type="checkbox"
              id="fastCashEnabled"
              checked={values.fastCashEnabled}
              onChange={handleFlagToggle}
            />
            <Label
              name="fastCashEnabled"
              title="FastCash enabled"
              errors={errors}
            />
          </div>

          <div className="input">
            <Label name="phoneNumber" title="Phone Number" errors={errors} />
            <Phone
              id="phoneNumber"
              countries={['US']}
              value={values.phoneNumber}
              onChange={handlePhoneNumberChange}
            />
          </div>

          <div className="input">
            <Label name="email" title="Email" errors={errors} />
            <Input id="email" value={values.email} onChange={handleChange} />
          </div>

          <div className="input">
            <Label
              name="customerServiceEmail"
              title="Customer Service Email"
              errors={errors}
            />
            <Input
              id="customerServiceEmail"
              value={values.customerServiceEmail}
              onChange={handleChange}
            />
          </div>
          <div className="input">
            <Label
              name="billingAddress"
              title="Billing Address"
              errors={errors}
            />
            <Input
              id="billingAddress"
              value={values.billingAddress}
              onChange={handleChange}
            />
          </div>
          <div className="is-featured-field checkbox">
            <input
              type="checkbox"
              id="isFeatured"
              checked={values.isFeatured}
              onChange={handleFlagToggle}
            />
            <Label name="isFeatured" title="Is Featured" errors={errors} />
          </div>
        </Column>
      </div>
      <div className="form-group-fields">
        <div className="input">
          <Label name="categoriesIds" title="Categories" errors={errors} />
          {categories.map((category) => {
            return (
              <CategoryCheckbox
                key={category.id}
                category={category}
                categoryIds={values.categoryIds}
                onCategoriesUpdate={onChange}
              />
            );
          })}
        </div>
      </div>
    </Group>
  );
};

export default StoreInfoForm;

StoreInfoForm.propTypes = {
  errors: PropTypes.shape(),
  values: PropTypes.shape().isRequired,
  categories: PropTypes.arrayOf(CategoryPresenter.shape()),
  onChange: PropTypes.func.isRequired,
  onCashbackRateChange: PropTypes.func.isRequired,
  storeId: PropTypes.string,
};

StoreInfoForm.defaultProps = {
  errors: null,
  categories: [],
  storeId: null,
};
